export const formatSToMMSSMS = (time: number) => {
  if (typeof time !== 'number') return '';
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  const milliseconds = Math.floor((time % 1) * 1000);

  const formattedM = minutes.toString().padStart(2, '0');
  const formattedS = seconds.toString().padStart(2, '0');
  const formattedMS = milliseconds.toString().padStart(3, '0');

  return `${formattedM}:${formattedS}:${formattedMS}`;
};

export const formatSToMMSS = (time: number) => {
  if (typeof time !== 'number') return '';
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);

  const formattedM = minutes.toString().padStart(2, '0');
  const formattedS = seconds.toString().padStart(2, '0');

  return `${formattedM}:${formattedS}`;
};

export const formatSToFullTime = (time: number) => {
  if (typeof time !== 'number') return '';
  const date = new Date(time);
  const year = date.getFullYear();
  const month = `0${date.getMonth() + 1}`.slice(-2);
  const day = `0${date.getDate()}`.slice(-2);
  const hours = `0${date.getHours()}`.slice(-2);
  const minutes = `0${date.getMinutes()}`.slice(-2);
  const seconds = `0${date.getSeconds()}`.slice(-2);
  const milliseconds = `00${date.getMilliseconds()}`.slice(-3);
  return `${year}-${month}-${day} ${hours}.${minutes}.${seconds}.${milliseconds}`;
};

// xAxis축의 시간을 표시하기 위해 사용
// MM:SS:MS 형식으로 표시
// TODO: 피드백 이후 형식 변경의 여지가 있음
// ISSUE-036: deliberately left without the `typeof time !== 'number'` guard its
// three siblings carry — the only caller (Editor/Axis.tsx) passes a d3 scale
// tick, which is always a number.
// The decisecond field also dropped a `padStart(1, '0')`. It was dead for EVERY
// input, not just the expected ones: padStart to length 1 pads only a string
// shorter than one character, and `String(<number>)` is never empty. The value
// range is irrelevant to that — and is not 0–9 anyway, because `%` keeps the
// dividend's sign, so negative input yields a negative field
// (formatXAxisTime(-90.5) === '-2:-31:-5'). Non-finite input yields 'NaN'.
// Verified by differential test over ~800k inputs: removal changes no output.
export const formatXAxisTime = (time: number) => {
  const minutes = Math.floor(time / 60);
  const seconds = Math.floor(time % 60);
  const milliseconds = Math.floor(((time % 1) * 1000) / 100);

  const formattedM = minutes.toString().padStart(2, '0');
  const formattedS = seconds.toString().padStart(2, '0');

  return `${formattedM}:${formattedS}:${milliseconds}`;
};
